import { atom } from 'jotai';
import type { SafeParseError } from 'zod';

export type ValidationResultItem = SafeParseError<unknown> & { id: string };

export const nodeValidationResultAtom = atom<ValidationResultItem[]>([]);
